import React, { useState } from "react";
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";
import { BiCheckDouble } from "react-icons/bi";
import { VscListFlat } from "react-icons/vsc";
import { PiPencilSimpleFill } from "react-icons/pi";
import Links from "../sub-components/Links";
const { PUBLIC_URL } = process.env;

const Feature8 = () => {

  const dashboard_Video = process.env.REACT_APP_DASHBOARD_VIDEO;

  const [activeIndex, setActiveIndex] = useState(0);
  const [imgSrc, setImgSrc] = useState(
    `${PUBLIC_URL}/assets/testPortal/selfGrading-tp-sec2-1.webp`
  );

  const handleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
    if (index === 0) {
      setImgSrc(`${PUBLIC_URL}/assets/testPortal/selfGrading-tp-sec2-1.webp`);
    }
    if (index === 1) {
      setImgSrc(`${PUBLIC_URL}/assets/testPortal/selfGrading-tp-sec2-2.webp`);
    }
    if (index === 2) {
      setImgSrc(`${PUBLIC_URL}/assets/testPortal/selfGrading-tp-sec2-3.webp`);
    }
    if (index === 3) {
      setImgSrc(`${PUBLIC_URL}/assets/testPortal/selfGrading-tp-sec2-4.webp`);
    }
    if (index === 4) {
      setImgSrc(`${PUBLIC_URL}/assets/testPortal/selfGrading-tp-sec2-5.webp`);
    }
    if (index === 5) {
      setImgSrc(`${PUBLIC_URL}/assets/testPortal/selfGrading-tp-sec2-6.webp`);
    }
  };

  return (
      <div>
        <section className="section main-banner" id="f8top">
          <video autoPlay muted loop id="bg-video">
            <source
              src={dashboard_Video}
              type="video/mp4"
            />
          </video>

          <div className="video-overlay header-text">
            <div className="caption">
              <h4 style={{ color: "#f5a425" }}>
                All the question types you will ever need{" "}
              </h4>
              <h6>
                NexTestify supports all popular assessment and test question
                <br />
                types. Mix and match the ones that best suit your needs.
              </h6>

              <div className="main-button">
                <div className="scroll-to-section">
                  <a href={`${PUBLIC_URL}/#section3`}>Sign up - it's free</a>
                </div>
              </div>
              <br />
              {/* <div>
                <a style={{ fontSize: "16px", color: "white" }}>Learn more</a>
                <br />
                <GoArrowDown style={{ color: "white" }} />
              </div> */}
            </div>
          </div>
        </section>

        <section className="dark-bg2">
          <div className="container-fluid dark-bg-sec">
            <div className="row f8sec1">
              <div className="col-lg-12 f8sec1head">
                <h4>Online test maker with a wide variety of options</h4>
                <h2>
                  Choose question types most suitable for your assessment.
                </h2>
              </div>

              <div className="col-lg-4 f8sec1content">
                <div>
                  <BiCheckDouble className="f8sec1contentIcon" />
                </div>

                <h3>Self-grading choice questions</h3>
                <p>
                  Single- and multiple-choice questions that are self-grading
                  and require no review from the test owner.
                </p>
              </div>

              <div className="col-lg-4 f8sec1content">
                <div>
                  <VscListFlat className="f8sec1contentIcon" />
                </div>
                <h3>Self-grading open-ended questions</h3>
                <p>
                  Short open-ended questions that are self-grading based on
                  pre-set criteria and require no additional review from the
                  test owner.
                </p>
              </div>
              <div className="col-lg-4 f8sec1content">
                <div>
                  <PiPencilSimpleFill className="f8sec1contentIcon" />
                </div>

                <h3>Descriptive open-ended questions</h3>
                <p>
                  Open-ended questions test respondents’ ability to provide
                  complex answers. These must be reviewed manually by the test
                  owner.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="img-bg">
          <div className="container-fluid img-bg-sec">
            <div className="row f8sec2">
              <div className="col-lg-12 f8sec2head">
                <h4>Make the most of your tests with our question editor</h4>
                <p>
                  Challenge and engage your respondents with a variety of
                  complex questions. Enrich your tests with audio and video
                  files that grab respondents’ attention.
                </p>
              </div>

              <div className="col-lg-6 f8sec2content">
                <ul>
                  {activeIndex === 0 ? (
                    <div className="panel">
                      <li
                        onClick={() => handleAccordion(0)}
                        style={{
                          color: "#f5a425",
                          cursor: "pointer",
                          fontWeight: "500",
                        }}
                      >
                        Attachments <MdKeyboardArrowUp />
                      </li>
                      <p>
                        Use a variety of test attachments: images, videos, audio
                        and pdf files. Spreadsheets and other files can be
                        downloaded, completed by the respondents, and then
                        uploaded as answers.
                      </p>
                    </div>
                  ) : (
                    <li
                      className="accordion"
                      onClick={() => handleAccordion(0)}
                      style={{
                        cursor: "pointer",
                        fontWeight: "500",
                      }}
                    >
                      Attachments <MdKeyboardArrowDown />
                    </li>
                  )}

                  {activeIndex === 1 ? (
                    <div className="panel">
                      <li
                        onClick={() => handleAccordion(1)}
                        style={{
                          color: "#f5a425",
                          cursor: "pointer",
                          fontWeight: "500",
                        }}
                      >
                        Equation editor <MdKeyboardArrowUp />
                      </li>
                      <p>
                        Complex mathematics, physics, or chemistry assessments
                        made easy with our excellent equation editor.
                      </p>
                    </div>
                  ) : (
                    <li
                      className="accordion"
                      onClick={() => handleAccordion(1)}
                      style={{
                        cursor: "pointer",
                        fontWeight: "500",
                      }}
                    >
                      Equation editor <MdKeyboardArrowDown />
                    </li>
                  )}

                  {activeIndex === 2 ? (
                    <div className="panel">
                      <li
                        onClick={() => handleAccordion(2)}
                        style={{
                          color: "#f5a425",
                          cursor: "pointer",
                          fontWeight: "500",
                        }}
                      >
                        All languages supported
                        <MdKeyboardArrowUp />
                      </li>
                      <p>
                        NexTestify supports assessments in all languages, so it
                        is easy to prepare tests for respondents from around the
                        world.
                      </p>
                    </div>
                  ) : (
                    <li
                      className="accordion"
                      onClick={() => handleAccordion(2)}
                      style={{
                        cursor: "pointer",
                        fontWeight: "500",
                      }}
                    >
                      All languages supported
                      <MdKeyboardArrowDown />
                    </li>
                  )}

                  {activeIndex === 3 ? (
                    <div className="panel">
                      <li
                        onClick={() => handleAccordion(3)}
                        style={{
                          color: "#f5a425",
                          cursor: "pointer",
                          fontWeight: "500",
                        }}
                      >
                        Complete question customization
                        <MdKeyboardArrowUp />
                      </li>
                      <p>
                        Our question editor allows you to use Rich Text
                        Formatting, as well as programming languages.
                      </p>
                    </div>
                  ) : (
                    <li
                      className="accordion"
                      onClick={() => handleAccordion(3)}
                      style={{
                        cursor: "pointer",
                        fontWeight: "500",
                      }}
                    >
                      Complete question customization
                      <MdKeyboardArrowDown />
                    </li>
                  )}

                  {activeIndex === 4 ? (
                    <div className="panel">
                      <li
                        onClick={() => handleAccordion(4)}
                        style={{
                          color: "#f5a425",
                          cursor: "pointer",
                          fontWeight: "500",
                        }}
                      >
                        Integrations with external content
                        <MdKeyboardArrowUp />
                      </li>
                      <p>
                        Make your assessments even more versatile and
                        interesting by adding external content and tools.
                      </p>
                    </div>
                  ) : (
                    <li
                      className="accordion"
                      onClick={() => handleAccordion(4)}
                      style={{
                        cursor: "pointer",
                        fontWeight: "500",
                      }}
                    >
                      Integrations with external content
                      <MdKeyboardArrowDown />
                    </li>
                  )}

                  {activeIndex === 5 ? (
                    <div className="panel">
                      <li
                        onClick={() => handleAccordion(5)}
                        style={{
                          color: "#f5a425",
                          cursor: "pointer",
                          fontWeight: "500",
                        }}
                      >
                        Scoring configuration <MdKeyboardArrowUp />
                      </li>
                      <p>
                        Depending on the complexity of your questions, you can
                        award partial, negative, or bonus points based on your
                        respondents’ performance.
                      </p>
                    </div>
                  ) : (
                    <li
                      className="accordion"
                      onClick={() => handleAccordion(5)}
                      style={{
                        cursor: "pointer",
                        fontWeight: "500",
                      }}
                    >
                      Scoring configuration <MdKeyboardArrowDown />
                    </li>
                  )}
                </ul>
              </div>

              <div className="col-md-12 col-lg-6 f8sec2img">
                <article className="video-item">
                  <figure>
                    <img src={imgSrc} alt="" />

                    <img
                      src={`${PUBLIC_URL}/assets/testPortal/yellow.svg`}
                      alt=""
                      className="overlay-image1"
                    />

                    <img
                      src={`${PUBLIC_URL}/assets/testPortal/green_big.svg`}
                      alt=""
                      className="overlay-image2"
                    />
                    <img
                      src={`${PUBLIC_URL}/assets/testPortal/green_big.svg`}
                      alt=""
                      className="overlay-image3"
                    />
                  </figure>
                </article>
              </div>
              {/* </div> */}
            </div>
          </div>
        </section>

        <section className="dark-bg">
          <div className="container-fluid dark-bg-sec">
            <div className="row f8sec3">
              <div className="col-md-12 col-lg-6 f8sec3img">
                <article className="video-item">
                  <figure>
                    <img
                      src={`${PUBLIC_URL}/assets/testPortal/selfGrading-tp2.webp`}
                      alt=""
                    />

                    <img
                      src={`${PUBLIC_URL}/assets/testPortal/green_curve_top.svg`}
                      alt=""
                      className="green_curve_top"
                    />

                    <img
                      src={`${PUBLIC_URL}/assets/testPortal/green_curve_bottom.svg`}
                      alt=""
                      className="green_curve_bottom"
                    />
                  </figure>
                </article>
              </div>

              <div className="col-lg-6 f8sec3content">
                <h3>Question categories prompt more insightful results</h3>
                <p>
                  Assign your questions to different categories to better assess
                  various aspects of the subject. Collect detailed results from
                  various categories to see partial scoring and draw better
                  conclusions from your test results.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="light-bg">
          <div className="container-fluid light-bg-sec">
            <div className="container f8sec4">
              <div className="f8sec4head">
                <h3>Use randomization to improve your assessments</h3>
              </div>

              <div className="f8sec4content">
                <ul>
                  {activeIndex === 0 ? (
                    <div className="panel2">
                      <li className="" onClick={() => handleAccordion(0)}>
                        Fixed order for all respondents <MdKeyboardArrowUp />
                      </li>
                      <p>
                        A single set of questions will be available for all of
                        your respondents. This is the most basic option and will
                        suit the majority of your needs. And if you require
                        more, NexTestify has amazing additional features for you
                        to explore.
                      </p>
                    </div>
                  ) : (
                    <li
                      className="accordion2"
                      onClick={() => handleAccordion(0)}
                    >
                      Fixed order for all respondents
                      <MdKeyboardArrowDown />
                    </li>
                  )}

                  {activeIndex === 1 ? (
                    <div className="panel2">
                      <li className="" onClick={() => handleAccordion(1)}>
                        Automatic selection from a question pool
                        <MdKeyboardArrowUp />
                      </li>
                      <p>
                        Decide how many questions our advanced algorithms should
                        randomly draw from a predefined list.{" "}
                      </p>
                    </div>
                  ) : (
                    <li
                      className="accordion2"
                      onClick={() => handleAccordion(1)}
                    >
                      Automatic selection from a question pool{" "}
                      <MdKeyboardArrowDown />
                    </li>
                  )}

                  {activeIndex === 2 ? (
                    <div className="panel2">
                      <li className="" onClick={() => handleAccordion(2)}>
                        {" "}
                        Random test sheet from a predefined pool{" "}
                        <MdKeyboardArrowUp />
                      </li>
                      <p>
                        Prepare several different versions of your test sets.
                        Each respondent will receive one of them at random.
                      </p>
                    </div>
                  ) : (
                    <li
                      className="accordion2"
                      onClick={() => handleAccordion(2)}
                    >
                      {" "}
                      Random test sheet from a predefined pool{" "}
                      <MdKeyboardArrowDown />
                    </li>
                  )}
                </ul>
              </div>
            </div>
          </div>
        </section>

        <section className="dark-bg2">
          <div className="container-fluid img-bg-sec">
            <div className="row f8sec5">
              <div className="col-lg-12 f8sec5head">
                <h4>Need a printed version? We’ve got you covered.</h4>
              </div>

              <div className="col-lg-6 f8sec5list">
                <ul>
                  <li>
                    <div className="f8sec5listdiv">
                      <h3>Test sheets</h3>
                      <p>
                        Prepare an online test, then print it for offline use.
                        Your tests can be reused whenever you need them again.
                      </p>
                    </div>
                  </li>
                  <li>
                    <div className="f8sec5listdiv">
                      <h3>Answers sheet</h3>
                      <p>
                        Save paper when doing offline assessments too. Answer
                        sheets allow you to use the same test sheets as many
                        times as you see fit.
                      </p>
                    </div>
                  </li>
                  <li>
                    <div className="f8sec5listdiv">
                      <h3>Answers key</h3>
                      <p>
                        The answer key is precisely the same size as the test
                        sheets and allows you to check and grade offline tests.
                      </p>
                    </div>
                  </li>
                </ul>
              </div>

              <div className="col-md-12 col-lg-6 sec5img">
                <article className="video-item">
                  <figure>
                    <img
                      src={`${PUBLIC_URL}/assets/testPortal/selfGrading-tp3.webp`}
                      alt=""
                      // className="background-image"
                    />

                    <img
                      src={`${PUBLIC_URL}/assets/testPortal/purple_curve_bottom.svg`}
                      alt=""
                      className="purple_curve_bottom"
                    />

                    <img
                      src={`${PUBLIC_URL}/assets/testPortal/yellow_curve_top.svg`}
                      alt=""
                      className="yellow_curve_top"
                    />
                  </figure>
                </article>
              </div>
            </div>
          </div>
        </section>

        <Links />
      </div>
   
  );
};

export default Feature8;
